/* eslint-disable react/prop-types */
import React from 'react';
import {Form} from 'informed';

import {DialogTitle} from '@material-ui/core';
import InviteForm from './form.invite';

function InviteFriendsForm({saving, className, onSubmit, onCancel, isOwner}) {
  return (
    <>
      <DialogTitle>Invite Extended Family & Friends</DialogTitle>
      <Form
        // eslint-disable-next-line react/jsx-props-no-spreading
        render={({...props}) => <InviteForm onCancel={onCancel} saving={saving} isOwner={isOwner} relationshipExamples="Family Friend, Cousin" {...props} />}
        initialValues={{permissions: 'viewer'}}
        onSubmit={values => onSubmit({...values, type: 'friend'})}
      />
    </>
  );
}

export default InviteFriendsForm;
